import React, { useEffect, useMemo, useState } from 'react';
import Header from '../../componentes/Header';
import Footer from '../../componentes/Footer';
import BarraLateral from '../../componentes/BarraLateral';
import api from '../../services/api';
import * as S from './styles';

const URL_BASE_SISTEMA = 'https://autobox.maisapoio.com.br';
const REDIRECT_URI_PADRAO = `${URL_BASE_SISTEMA}/integracoes/whatsapp/meta/cadastro-incorporado/callback`;

function novaMensagem() {
  return { tipo: '', texto: '' };
}

const estadoChecklistInicial = {
  appCriado: false,
  permissaoWhatsAppGerenciada: false,
  webhookConfigurado: false,
  tokenSistemaValido: false,
  backupConversaRealizado: false,
  aceiteTermosMeta: false
};

const itensChecklist = [
  {
    chave: 'appCriado',
    etapa: 1,
    ordem: 1,
    etapaTitulo: 'Preparacao da conta Meta',
    titulo: 'App Meta criado e vinculado ao portfolio empresarial correto.'
  },
  {
    chave: 'permissaoWhatsAppGerenciada',
    etapa: 1,
    ordem: 2,
    etapaTitulo: 'Preparacao da conta Meta',
    titulo: 'Permissao WhatsApp Business Management concedida para usuario de sistema.'
  },
  {
    chave: 'webhookConfigurado',
    etapa: 2,
    ordem: 1,
    etapaTitulo: 'Configuracao tecnica',
    titulo: 'Webhook configurado e com evento messages habilitado.'
  },
  {
    chave: 'tokenSistemaValido',
    etapa: 2,
    ordem: 2,
    etapaTitulo: 'Configuracao tecnica',
    titulo: 'Token de sistema com validade e escopos conferidos para o ambiente.'
  },
  {
    chave: 'backupConversaRealizado',
    etapa: 3,
    ordem: 1,
    etapaTitulo: 'Seguranca e governanca',
    titulo: 'Backup operacional e plano de contingencia definidos antes da migracao.'
  },
  {
    chave: 'aceiteTermosMeta',
    etapa: 3,
    ordem: 2,
    etapaTitulo: 'Seguranca e governanca',
    titulo: 'Termos de uso e politicas da Meta aceitos para API e mensageria comercial.'
  }
];

const dicasCampos = {
  appId: 'Identificador unico do seu aplicativo na Meta. E usado para autenticar o fluxo de onboarding.',
  appSecret: 'Chave privada do aplicativo Meta. Nunca compartilhe em canais publicos.',
  businessManagerId: 'ID do portfolio empresarial (Business Manager) que sera dono da integracao.',
  configIdCadastroIncorporado: 'Identificador da configuracao do Embedded Signup criada no app Meta.',
  redirectUri:
    'URL para onde a Meta redireciona o usuario apos autorizar o Embedded Signup. Essa URL precisa estar cadastrada nas configuracoes do app Meta.',
  webhookVerifyToken: 'Token usado para validar o webhook da Meta no handshake inicial.',
  versaoGraphApi: 'Versao da API Graph usada nos endpoints da integracao.',
  wabaId: 'ID da conta WhatsApp Business (WABA) vinculada ao numero.',
  phoneNumberId: 'ID interno do numero no WhatsApp Business Platform.',
  numeroE164: 'Numero no formato internacional E.164, sem espacos. Ex.: 5511999990000.',
  nomeExibicao: 'Nome visivel para clientes no WhatsApp.',
  pinSeisDigitos: 'PIN de 6 digitos usado em validacoes de seguranca da linha.',
  tipoHospedagemAtual: 'Origem atual da linha para orientar o fluxo correto de coexistencia.',
  callbackUrlMigracao: 'Endpoint para receber eventos de migracao e status da coexistencia.',
  fusoHorario: 'Fuso horario de referencia para eventos e janelas operacionais.'
};

function valorBooleano(objeto, chaves, fallback = false) {
  const fonte = objeto || {};
  for (let i = 0; i < chaves.length; i += 1) {
    const valor = fonte[chaves[i]];
    if (typeof valor === 'boolean') {
      return valor;
    }
  }
  return fallback;
}

function montarChecklistAutomatico({ checklistApi, cadastro, coexistencia, tokenSistema }) {
  const dadosChecklist = checklistApi || {};

  const appCriadoInferido = Boolean(
    String(cadastro.appId || '').trim() && String(cadastro.businessManagerId || '').trim()
  );

  const webhookInferido = Boolean(
    String(cadastro.webhookVerifyToken || '').trim() || String(coexistencia.callbackUrlMigracao || '').trim()
  );

  return {
    appCriado: valorBooleano(dadosChecklist, ['appCriado', 'app_created', 'app_ready'], appCriadoInferido),
    permissaoWhatsAppGerenciada: valorBooleano(
      dadosChecklist,
      ['permissaoWhatsAppGerenciada', 'whatsappManagementPermission', 'permission_whatsapp_management'],
      false
    ),
    webhookConfigurado: valorBooleano(dadosChecklist, ['webhookConfigurado', 'webhook_ready'], webhookInferido),
    tokenSistemaValido: valorBooleano(
      dadosChecklist,
      ['tokenSistemaValido', 'systemTokenValid', 'token_valid'],
      Boolean(String(tokenSistema || '').trim())
    ),
    backupConversaRealizado: valorBooleano(
      dadosChecklist,
      ['backupConversaRealizado', 'backup_done', 'backup_ready'],
      false
    ),
    aceiteTermosMeta: valorBooleano(dadosChecklist, ['aceiteTermosMeta', 'termsAccepted', 'terms_accepted'], false)
  };
}

export default function MetaSetup() {
  const [carregando, setCarregando] = useState(false);
  const [carregandoInicial, setCarregandoInicial] = useState(true);
  const [mensagem, setMensagem] = useState(novaMensagem());
  const [mensagemCoexistencia, setMensagemCoexistencia] = useState(novaMensagem());

  const [cadastroIncorporado, setCadastroIncorporado] = useState({
    appId: '',
    appSecret: '',
    businessManagerId: '',
    configIdCadastroIncorporado: '',
    redirectUri: REDIRECT_URI_PADRAO,
    webhookVerifyToken: '',
    versaoGraphApi: 'v25.0'
  });

  const [coexistencia, setCoexistencia] = useState({
    wabaId: '',
    phoneNumberId: '',
    numeroE164: '',
    nomeExibicao: '',
    pinSeisDigitos: '',
    tipoHospedagemAtual: 'aplicativo_celular',
    callbackUrlMigracao: '',
    fusoHorario: 'America/Sao_Paulo'
  });

  const [checklistMeta, setChecklistMeta] = useState(estadoChecklistInicial);

  const [statusAtual, setStatusAtual] = useState({
    fase: 'nao_iniciado',
    numeroRegistrado: '-'
  });

  const [tokenSistemaAtual, setTokenSistemaAtual] = useState('');
  const [urlCadastroIncorporado, setUrlCadastroIncorporado] = useState('');
  const [ajudaCampoAtivo, setAjudaCampoAtivo] = useState('');
  const [mostrarEdicaoPreparacao, setMostrarEdicaoPreparacao] = useState(false);

  const botoesBarra = useMemo(() => ([
    { key: 'autoboox', label: 'Autoboox', to: '/autoboox' },
    { key: 'meta_setup', label: 'Meta Setup', to: '/autoboox/meta-setup' }
  ]), []);

  const checklistPorEtapa = useMemo(() => {
    const agrupado = itensChecklist
      .slice()
      .sort((a, b) => a.etapa - b.etapa || a.ordem - b.ordem)
      .reduce((acumulador, item) => {
        const chaveGrupo = String(item.etapa);

        if (!acumulador[chaveGrupo]) {
          acumulador[chaveGrupo] = {
            etapa: item.etapa,
            etapaTitulo: item.etapaTitulo,
            itens: []
          };
        }

        acumulador[chaveGrupo].itens.push(item);
        return acumulador;
      }, {});

    return Object.values(agrupado).sort((a, b) => a.etapa - b.etapa);
  }, []);

  const etapaPreparacaoConcluida = Boolean(
    checklistMeta.appCriado && checklistMeta.permissaoWhatsAppGerenciada
  );

  const ocultarInputsPreparacao = Boolean(
    etapaPreparacaoConcluida && !mostrarEdicaoPreparacao
  );

  function atualizarCampoCadastro(campo, valor) {
    setCadastroIncorporado((anterior) => ({ ...anterior, [campo]: valor }));
  }

  function atualizarCampoCoexistencia(campo, valor) {
    setCoexistencia((anterior) => ({ ...anterior, [campo]: valor }));
  }

  function alternarAjudaCampo(chave) {
    setAjudaCampoAtivo((anterior) => (anterior === chave ? '' : chave));
  }

  function renderTituloComAjuda(chave, titulo) {
    const textoAjuda = dicasCampos[chave];
    const aberto = ajudaCampoAtivo === chave;

    return (
      <>
        <S.campoTopo>
          <S.campoTitulo>{titulo}</S.campoTitulo>
          <S.ajudaBotao
            type='button'
            onClick={(evento) => {
              evento.preventDefault();
              alternarAjudaCampo(chave);
            }}
            aria-label={`Ajuda sobre ${titulo}`}
            aria-expanded={aberto}
            title={`Ajuda sobre ${titulo}`}
          >
            i
          </S.ajudaBotao>
        </S.campoTopo>
        {aberto && textoAjuda ? <S.ajudaTexto>{textoAjuda}</S.ajudaTexto> : null}
      </>
    );
  }

  function normalizarErro(erro, fallback) {
    return erro?.response?.data?.message || erro?.response?.data?.erro || fallback;
  }

  function mascararValor(valor, exibicaoMinima = 6) {
    const texto = String(valor || '').trim();
    if (!texto) return '-';
    if (texto.length <= exibicaoMinima) return texto;
    return `${texto.slice(0, exibicaoMinima)}...`;
  }

  async function consultarStatus() {
    try {
      const { data } = await api.get('/integracoes/whatsapp/meta/coexistencia/status');
      setStatusAtual({
        fase: data?.fase || 'nao_iniciado',
        numeroRegistrado: data?.numeroRegistrado || '-'
      });
      return data || {};
    } catch (erro) {
      setStatusAtual((anterior) => ({ ...anterior }));
      return null;
    }
  }

  function aplicarDadosCadastroMeta(dadosMeta, dadosOficial) {
    const meta = dadosMeta || {};
    const oficial = dadosOficial || {};

    setCadastroIncorporado((anterior) => ({
      ...anterior,
      appId: meta?.appId || oficial?.appId || anterior.appId,
      businessManagerId:
        meta?.businessManagerId || meta?.businessAccountId || oficial?.businessAccountId || anterior.businessManagerId,
      configIdCadastroIncorporado: meta?.configIdCadastroIncorporado || meta?.configId || anterior.configIdCadastroIncorporado,
      redirectUri: meta?.redirectUri || anterior.redirectUri,
      webhookVerifyToken: meta?.webhookVerifyToken || oficial?.webhookVerifyToken || anterior.webhookVerifyToken,
      versaoGraphApi: meta?.versaoGraphApi || meta?.graphVersion || anterior.versaoGraphApi
    }));

    setCoexistencia((anterior) => ({
      ...anterior,
      wabaId: meta?.wabaId || oficial?.templatesWabaId || oficial?.businessAccountId || anterior.wabaId,
      phoneNumberId: meta?.phoneNumberId || oficial?.phoneNumberId || anterior.phoneNumberId,
      numeroE164: meta?.numeroE164 || meta?.phoneNumber || anterior.numeroE164,
      nomeExibicao: meta?.nomeExibicao || meta?.displayName || anterior.nomeExibicao,
      callbackUrlMigracao: meta?.callbackUrlMigracao || meta?.webhookUrl || anterior.callbackUrlMigracao,
      tipoHospedagemAtual: meta?.tipoHospedagemAtual || anterior.tipoHospedagemAtual,
      fusoHorario: meta?.fusoHorario || anterior.fusoHorario
    }));

    setTokenSistemaAtual(meta?.systemUserAccessToken || oficial?.systemUserAccessToken || '');
  }

  async function carregarDadosIniciais() {
    setCarregandoInicial(true);

    const respostas = await Promise.allSettled([
      api.get('/integracoes/whatsapp/meta/cadastro-incorporado/configuracao'),
      api.get('/integracoes/whatsapp/meta/cadastro-incorporado/checklist'),
      api.get('/integracoes/whatsapp/oficial/configuracao'),
      api.get('/integracoes/whatsapp/meta/coexistencia/configuracao'),
      api.get('/integracoes/whatsapp/meta/coexistencia/status')
    ]);

    const cadastroMeta = respostas[0].status === 'fulfilled' ? respostas[0].value?.data || {} : {};
    const checklistMetaApi = respostas[1].status === 'fulfilled' ? respostas[1].value?.data || {} : {};
    const configuracaoOficial = respostas[2].status === 'fulfilled' ? respostas[2].value?.data || {} : {};
    const configuracaoCoexistencia = respostas[3].status === 'fulfilled' ? respostas[3].value?.data || {} : {};
    const statusMeta = respostas[4].status === 'fulfilled' ? respostas[4].value?.data || {} : null;

    aplicarDadosCadastroMeta({ ...cadastroMeta, ...configuracaoCoexistencia }, configuracaoOficial);

    if (statusMeta) {
      setStatusAtual({
        fase: statusMeta?.fase || 'nao_iniciado',
        numeroRegistrado: statusMeta?.numeroRegistrado || '-'
      });
    } else {
      await consultarStatus();
    }

    const checklistCombinado = montarChecklistAutomatico({
      checklistApi: checklistMetaApi?.checklist || checklistMetaApi,
      cadastro: { ...cadastroMeta, ...configuracaoOficial },
      coexistencia: configuracaoCoexistencia,
      tokenSistema: cadastroMeta?.systemUserAccessToken || configuracaoOficial?.systemUserAccessToken
    });

    setChecklistMeta(checklistCombinado);
    setCarregandoInicial(false);
  }

  function validarChecklistMeta() {
    const itensPendentes = Object.entries(checklistMeta).filter(([, valor]) => !valor);

    if (itensPendentes.length > 0) {
      setMensagemCoexistencia({
        tipo: 'erro',
        texto: 'Existem pre-requisitos da Meta pendentes. Corrija os itens em vermelho antes de continuar.'
      });
      return false;
    }

    return true;
  }

  async function salvarCadastroIncorporado() {
    setCarregando(true);
    setMensagem(novaMensagem());

    try {
      await api.post('/integracoes/whatsapp/meta/cadastro-incorporado/configurar', {
        ...cadastroIncorporado
      });

      setMensagem({ tipo: 'sucesso', texto: 'Configuracao do Cadastro Incorporado salva com sucesso.' });
      await carregarDadosIniciais();
    } catch (erro) {
      setMensagem({
        tipo: 'erro',
        texto: normalizarErro(erro, 'Nao foi possivel salvar o Cadastro Incorporado da Meta.')
      });
    } finally {
      setCarregando(false);
    }
  }

  async function gerarLinkCadastroIncorporado() {
    setCarregando(true);
    setMensagem(novaMensagem());

    try {
      const { data } = await api.post('/integracoes/whatsapp/meta/cadastro-incorporado/gerar-url', {
        redirectUri: cadastroIncorporado.redirectUri,
        configIdCadastroIncorporado: cadastroIncorporado.configIdCadastroIncorporado
      });

      setUrlCadastroIncorporado(String(data?.url || ''));
      setMensagem({
        tipo: 'sucesso',
        texto: 'Link de Cadastro Incorporado gerado. Compartilhe com o gestor que vai concluir o onboarding.'
      });
    } catch (erro) {
      setMensagem({
        tipo: 'erro',
        texto: normalizarErro(erro, 'Nao foi possivel gerar o link de Cadastro Incorporado.')
      });
    } finally {
      setCarregando(false);
    }
  }

  async function validarPreRequisitosCoexistencia() {
    if (!validarChecklistMeta()) return;

    setCarregando(true);
    setMensagemCoexistencia(novaMensagem());

    try {
      const { data } = await api.post('/integracoes/whatsapp/meta/coexistencia/validar-pre-requisitos', {
        wabaId: coexistencia.wabaId,
        phoneNumberId: coexistencia.phoneNumberId,
        numeroE164: coexistencia.numeroE164,
        tipoHospedagemAtual: coexistencia.tipoHospedagemAtual
      });

      setMensagemCoexistencia({
        tipo: 'sucesso',
        texto: data?.message || 'Pre-requisitos validados com sucesso. Pronto para registrar o numero em coexistencia.'
      });
      await carregarDadosIniciais();
    } catch (erro) {
      setMensagemCoexistencia({
        tipo: 'erro',
        texto: normalizarErro(erro, 'Nao foi possivel validar os pre-requisitos da coexistencia.')
      });
    } finally {
      setCarregando(false);
    }
  }

  async function registrarNumeroCoexistencia() {
    if (!validarChecklistMeta()) return;

    setCarregando(true);
    setMensagemCoexistencia(novaMensagem());

    try {
      await api.post('/integracoes/whatsapp/meta/coexistencia/registrar-numero', {
        ...coexistencia
      });

      setMensagemCoexistencia({
        tipo: 'sucesso',
        texto: 'Solicitacao enviada para Meta. Aguarde a validacao do numero e conclua a verificacao solicitada.'
      });
      await carregarDadosIniciais();
    } catch (erro) {
      setMensagemCoexistencia({
        tipo: 'erro',
        texto: normalizarErro(erro, 'Nao foi possivel registrar o numero na coexistencia.')
      });
    } finally {
      setCarregando(false);
    }
  }

  async function confirmarAtivacaoCoexistencia() {
    setCarregando(true);
    setMensagemCoexistencia(novaMensagem());

    try {
      const { data } = await api.post('/integracoes/whatsapp/meta/coexistencia/confirmar-ativacao', {
        phoneNumberId: coexistencia.phoneNumberId,
        numeroE164: coexistencia.numeroE164
      });

      setMensagemCoexistencia({ tipo: 'sucesso', texto: data?.message || 'Ativacao confirmada com sucesso.' });
      await carregarDadosIniciais();
    } catch (erro) {
      setMensagemCoexistencia({
        tipo: 'erro',
        texto: normalizarErro(erro, 'Nao foi possivel confirmar a ativacao da coexistencia.')
      });
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregarDadosIniciais();
  }, []);

  useEffect(() => {
    if (etapaPreparacaoConcluida) {
      setMostrarEdicaoPreparacao(false);
    }
  }, [etapaPreparacaoConcluida]);

  return (
    <S.pagina>
      <Header playLogo={false} />

      <BarraLateral customButtons={botoesBarra} activeKey='meta_setup' />

      <S.miolo>
        <S.hero>
          <h1>Cadastro Incorporado e Coexistencia Meta</h1>
          <p>
            Configure os dados principais da Meta e execute o fluxo de coexistencia com checklist automatico.
          </p>
        </S.hero>

        {carregandoInicial ? (
          <S.blocoStatus $tipo='sucesso'>Carregando configuracoes ja existentes da Meta...</S.blocoStatus>
        ) : null}

        <S.grade>
          <S.card>
            <h2>Configuracao do Cadastro Incorporado</h2>
            <p>
              {ocultarInputsPreparacao
                ? 'Etapa de preparacao concluida. Abaixo estao as informacoes principais e o link ativo.'
                : 'Os campos abaixo sao preenchidos automaticamente com o que ja existe no sistema e na Meta.'}
            </p>

            {ocultarInputsPreparacao ? (
              <>
                <S.blocoStatus $tipo='sucesso'>Preparacao concluida com sucesso.</S.blocoStatus>

                <S.linhaAcoes>
                  <S.botao type='button' onClick={() => setMostrarEdicaoPreparacao(true)} disabled={carregando}>
                    Editar dados
                  </S.botao>
                </S.linhaAcoes>
              </>
            ) : (
              <>
                <S.gradeCampos>
                  <S.campo>
                    {renderTituloComAjuda('appId', 'App ID')}
                    <input
                      value={cadastroIncorporado.appId}
                      onChange={(evento) => atualizarCampoCadastro('appId', evento.target.value)}
                      placeholder='Ex.: 123456789'
                    />
                  </S.campo>

                  <S.campo>
                    {renderTituloComAjuda('appSecret', 'App Secret')}
                    <input
                      type='password'
                      value={cadastroIncorporado.appSecret}
                      onChange={(evento) => atualizarCampoCadastro('appSecret', evento.target.value)}
                      placeholder='Segredo do app Meta'
                    />
                  </S.campo>

                  <S.campo>
                    {renderTituloComAjuda('businessManagerId', 'Business Manager ID')}
                    <input
                      value={cadastroIncorporado.businessManagerId}
                      onChange={(evento) => atualizarCampoCadastro('businessManagerId', evento.target.value)}
                      placeholder='ID do portfolio empresarial'
                    />
                  </S.campo>

                  <S.campo>
                    {renderTituloComAjuda('configIdCadastroIncorporado', 'Config ID do Embedded Signup')}
                    <input
                      value={cadastroIncorporado.configIdCadastroIncorporado}
                      onChange={(evento) => atualizarCampoCadastro('configIdCadastroIncorporado', evento.target.value)}
                      placeholder='Config ID fornecido na Meta'
                    />
                  </S.campo>

                  <S.campo>
                    {renderTituloComAjuda('redirectUri', 'Redirect URI')}
                    <input
                      value={cadastroIncorporado.redirectUri}
                      onChange={(evento) => atualizarCampoCadastro('redirectUri', evento.target.value)}
                      placeholder={REDIRECT_URI_PADRAO}
                    />
                  </S.campo>

                  <S.campo>
                    {renderTituloComAjuda('webhookVerifyToken', 'Token de verificacao do Webhook')}
                    <input
                      value={cadastroIncorporado.webhookVerifyToken}
                      onChange={(evento) => atualizarCampoCadastro('webhookVerifyToken', evento.target.value)}
                      placeholder='Token para challenge do webhook'
                    />
                  </S.campo>

                  <S.campo>
                    {renderTituloComAjuda('versaoGraphApi', 'Versao Graph API')}
                    <select
                      value={cadastroIncorporado.versaoGraphApi}
                      onChange={(evento) => atualizarCampoCadastro('versaoGraphApi', evento.target.value)}
                    >
                      <option value='v25.0'>v25.0 (recomendado)</option>
                      <option value='v24.0'>v24.0</option>
                    </select>
                  </S.campo>
                </S.gradeCampos>

                <S.linhaAcoes>
                  <S.botao $variant='primario' type='button' onClick={salvarCadastroIncorporado} disabled={carregando}>
                    {carregando ? 'Processando...' : 'Salvar configuracao'}
                  </S.botao>
                  <S.botao type='button' onClick={gerarLinkCadastroIncorporado} disabled={carregando}>
                    {carregando ? 'Processando...' : 'Gerar link cadastro incorporado'}
                  </S.botao>
                  {mostrarEdicaoPreparacao && (
                    <S.botao type='button' onClick={() => setMostrarEdicaoPreparacao(false)} disabled={carregando}>
                      Fechar edicao
                    </S.botao>
                  )}
                </S.linhaAcoes>
              </>
            )}

            {mensagem.texto ? (
              <S.blocoStatus $tipo={mensagem.tipo === 'erro' ? 'erro' : 'sucesso'}>{mensagem.texto}</S.blocoStatus>
            ) : null}

            {!ocultarInputsPreparacao && urlCadastroIncorporado ? (
              <S.blocoStatus $tipo='sucesso'>URL gerada: {urlCadastroIncorporado}</S.blocoStatus>
            ) : null}
          </S.card>
        </S.grade>

        <S.grade>
          <S.card>
            <h2>Dados tecnicos da Coexistencia</h2>
            <p>Preenchimento automatico ativo. Ajuste apenas quando necessario.</p>

            <S.gradeCampos>
              <S.campo>
                {renderTituloComAjuda('wabaId', 'WABA ID')}
                <input
                  value={coexistencia.wabaId}
                  onChange={(evento) => atualizarCampoCoexistencia('wabaId', evento.target.value)}
                  placeholder='ID da conta WhatsApp Business'
                />
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('phoneNumberId', 'Phone Number ID')}
                <input
                  value={coexistencia.phoneNumberId}
                  onChange={(evento) => atualizarCampoCoexistencia('phoneNumberId', evento.target.value)}
                  placeholder='ID numerico do telefone'
                />
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('numeroE164', 'Numero em E.164')}
                <input
                  value={coexistencia.numeroE164}
                  onChange={(evento) => atualizarCampoCoexistencia('numeroE164', evento.target.value)}
                  placeholder='Ex.: 5511999990000'
                />
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('nomeExibicao', 'Nome de exibicao')}
                <input
                  value={coexistencia.nomeExibicao}
                  onChange={(evento) => atualizarCampoCoexistencia('nomeExibicao', evento.target.value)}
                  placeholder='Nome que aparece para o cliente'
                />
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('pinSeisDigitos', 'PIN de 6 digitos')}
                <input
                  value={coexistencia.pinSeisDigitos}
                  onChange={(evento) => atualizarCampoCoexistencia('pinSeisDigitos', evento.target.value)}
                  placeholder='Somente numeros'
                />
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('tipoHospedagemAtual', 'Tipo da origem atual')}
                <select
                  value={coexistencia.tipoHospedagemAtual}
                  onChange={(evento) => atualizarCampoCoexistencia('tipoHospedagemAtual', evento.target.value)}
                >
                  <option value='aplicativo_celular'>Aplicativo no celular</option>
                  <option value='provedor_bsp'>Provedor BSP</option>
                  <option value='outra_api'>Outra API</option>
                </select>
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('callbackUrlMigracao', 'Callback de migracao')}
                <input
                  value={coexistencia.callbackUrlMigracao}
                  onChange={(evento) => atualizarCampoCoexistencia('callbackUrlMigracao', evento.target.value)}
                  placeholder='https://seu-dominio/webhooks/meta/coexistencia'
                />
              </S.campo>

              <S.campo>
                {renderTituloComAjuda('fusoHorario', 'Fuso horario da operacao')}
                <select
                  value={coexistencia.fusoHorario}
                  onChange={(evento) => atualizarCampoCoexistencia('fusoHorario', evento.target.value)}
                >
                  <option value='America/Sao_Paulo'>America/Sao_Paulo</option>
                  <option value='America/Manaus'>America/Manaus</option>
                  <option value='America/Recife'>America/Recife</option>
                </select>
              </S.campo>
            </S.gradeCampos>

            <S.linhaAcoes>
              <S.botao type='button' onClick={validarPreRequisitosCoexistencia} disabled={carregando}>
                Validar pre-requisitos
              </S.botao>
              <S.botao $variant='primario' type='button' onClick={registrarNumeroCoexistencia} disabled={carregando}>
                Registrar numero coexistencia
              </S.botao>
              <S.botao type='button' onClick={confirmarAtivacaoCoexistencia} disabled={carregando}>
                Confirmar ativacao
              </S.botao>
            </S.linhaAcoes>

            {mensagemCoexistencia.texto ? (
              <S.blocoStatus $tipo={mensagemCoexistencia.tipo === 'erro' ? 'erro' : 'sucesso'}>
                {mensagemCoexistencia.texto}
              </S.blocoStatus>
            ) : null}
          </S.card>

          <S.card>
            <h2>Checklist obrigatorio Meta</h2>
            <p>Status automatico: verde para implementado e vermelho para pendencia.</p>

            <S.quadroRequisitos>
              <h3>Pre-requisitos detectados no cadastro Meta</h3>

              {checklistPorEtapa.map((grupo) => (
                <S.etapaChecklist key={grupo.etapa}>
                  <S.etapaChecklistTitulo>
                    Etapa {grupo.etapa}: {grupo.etapaTitulo}
                  </S.etapaChecklistTitulo>

                  <S.checklist>
                    {grupo.itens.map((item) => {
                      const ok = Boolean(checklistMeta[item.chave]);

                      return (
                        <S.checkItem key={item.chave} $ok={ok}>
                          <input type='checkbox' checked={ok} readOnly />
                          <span>{item.ordem}. {item.titulo}</span>
                          <S.statusTag $ok={ok}>{ok ? 'Implementado' : 'Pendente'}</S.statusTag>
                        </S.checkItem>
                      );
                    })}
                  </S.checklist>
                </S.etapaChecklist>
              ))}
            </S.quadroRequisitos>

            <S.blocoStatus $tipo='sucesso'>Fase atual: {statusAtual.fase} | Numero registrado: {statusAtual.numeroRegistrado}</S.blocoStatus>
            <S.blocoStatus $tipo={tokenSistemaAtual ? 'sucesso' : 'erro'}>
              Token de sistema {tokenSistemaAtual ? 'detectado no cadastro atual.' : 'nao detectado no cadastro atual.'}
            </S.blocoStatus>
          </S.card>
        </S.grade>
      </S.miolo>

      <Footer />
    </S.pagina>
  );
}
